import { Box, Tooltip, useToast } from "@chakra-ui/react"

export default function Clipboard({ children, copy, ...props }){

    const toast = useToast()

    const handleCopy = () => {
        navigator.clipboard.writeText(copy ?? children)
        toast({ description: 'Texto copiado para a área de transferência.', position: 'bottom-right', duration: 1000 })
    }

    return(
    <Tooltip label="Clique para copiar"><Box cursor="pointer" onClick={handleCopy} __css={{ transition: 'all 300ms' }} _hover={{ opacity: 0.5 }} _active={{ opacity: 1, transform: 'scale(0.99)' }} {...props}>{children}</Box></Tooltip>
    )
}